import { render, staticRenderFns } from "./AutoPostBoostingAction.vue?vue&type=template&id=80590252&scoped=true&"
import script from "./AutoPostBoostingAction.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingAction.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingAction.vue?vue&type=style&index=0&id=80590252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80590252",
  null
  
)

export default component.exports